import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/login/Login'
// import forgetpwd from '@/components/login/forgetpwd'
// import register from '@/components/login/register'
// const routers = [
//   {
//     path:'/',
//     meta:{
//       title:'登录'
//     },
//     component:(resolve)=> require(['../components/login/Login.vue'], resolve)
//   },
// ]
import BasicIndex from '@/components/navMain/mainComponents/BasicIndex'
import BasicSecond from '@/components/navMain/mainComponents/secondDetail'

Vue.use(Router)
//解决this.$router.push({path: "path"}) , 跳转时出现错误.
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
import router from "./router";
const env = process.env.NODE_ENV;
export function makeOriginRoutes(){
  return [
    {//订单，佣金支付页面
      name:'fullSale',
      path: '/fullSale',
      component: BasicIndex,
      meta: {
        title: '订单信息',
        keepAlive: true,
        isFrame:true,
      }
    },
    {
      path: '/',
      name: 'login',
      component: (resolve) => require(['../components/login/Login.vue'], resolve),
      meta: {
        title: '登录',
        keepAlive: true
      }
    },
    {
      path: '/forgetpwd',

      component: (resolve) => require(['../components/login/forgetpwd.vue'], resolve),
      meta: {
        title: '忘记密码',
        keepAlive: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/page/user/register.vue'),
      meta: {
        title: '注册',
        keepAlive: true
      }
    },
    {
      path: '/AppMain',
      name: 'AppMain',
      component: (resolve) => require(['../components/main/AppMain.vue'], resolve),
      meta: {
        title: '入口页面',
        keepAlive: true
      },
      children: [
        {
          path: '/backDetail',
          name: 'backDetail',
          component: () => import('@/page/order/backDetail'),
          meta: {
            title: '退货详情',
            keepAlive: true,
          },
        },
        {
          name: 'dealerBackList',
          path: '/dealerBackList',
          component: () => import('@/page/order/dealerBackList'),
          meta: {
            title: '卖家退货单列表',
            keepAlive: true,
          },
        },
        {
          name: 'buyerBackList',
          path: '/buyerBackList',
          component: () => import('@/page/order/buyerBackList'),
          meta: {
            title: '买家退货单列表',
            keepAlive: true,
          },
        },
        {
          name:'HomeNotice',
          path: '/HomeNotice',
          component: ()=>import('@/page/home/notice'),
          meta: {
            title:'首页公告',
            keepAlive: true,
          }
        },
        {
          name:'queryEnquiryInfoListxlc',
          path:'/queryEnquiryInfoListxlc',
          component:BasicIndex,
          meta: {
            title: '待下单(修理厂)',
            keepAlive: true,
            isFrame: true,
          },
        },
        {
          name:'ProductDetail',
          path:'/ProductDetail',
          component:()=>import('@/components/repairFactory/ProductDetail'),
          meta:{
            title:'商品详情',
            keepAlive: true
          }
        },
        {
          name:'applyInvoiceList',
          path:'/applyInvoiceList',
          component:()=>import('@/page/invoice/InvoiceList'),
          meta:{
            title: '申请发票列表',
            keepAlive: true
          }
        },
        {
          name:'ShippingAddress',
          path:'/ShippingAddress',
          component:()=>import('@/page/AddressManage/ShippingAddress'),
          meta:{
            title: '收货地址',
            keepAlive: true
          }
        },
        {
          name:'InvoiceManage',
          path:'/InvoiceManage',
          component:()=>import('@/page/invoice/InvoiceManage'),
          meta:{
            title: '发票管理',
            keepAlive: true
          }
        },
        {
          name:'factoryNoticeList',
          path:'/factoryNoticeList',
          component:()=>import('@/components/repairFactory/NoticeList'),
          meta:{
            keepAlive: true,
            title: '公告',
          }
        },
        {
          name:'factoryOrder',
          path:'/factoryOrder',
          component: ()=>import('@/page/shop/factoryOrder'),
          meta:{
            keepAlive: true,
            title: '下单',
            isFrame: false
          }
        },
        {
          name:'factoryShopIndex',
          path:'/factoryShopIndex',
          component:()=>import('@/components/repairFactory/ShopIndex.vue'),
          meta:{
            keepAlive: true,
            title: '商城首页'
          },
        },
        {
          name:'factoryShopBuyCar',
          path:'/factoryShopBuyCar',
          component:()=>import('@/components/repairFactory/BuyCar.vue'),
          meta:{
            keepAlive: true,
            title: '商城购物车'
          },
        },
        {
          name:'factoryOrderDetail',
          path:'/factoryOrderDetail',
          component:BasicSecond,
          meta:{
            keepAlive: true,
            title: '下单详情',
            isFrame: true
          },
        },
        {
          name:"shop",
          path:'/shop',
          component:BasicIndex,
          meta:{
            keepAlive: true,
            title: '商城'
          },
          children:[

          ],
        },
        {
          name:'xlcInquiryDetailTemporaryStorage',
          path:'/xlcInquiryDetailTemporaryStorage',
          component:BasicSecond,
          meta:{
            keepAlive: true,
            isFrame: true,
            title: '暂存'
          }
        },
        {
          name:'xlcInquiryDetail',
          path:'/xlcInquiryDetail',
          component:BasicSecond,
          meta:{
            keepAlive: true,
            isFrame: true,
            title: '询价单详情'
          }
        },
        {
          name:'xlcmbDetailTemporaryStorage',
          path:'/xlcmbDetailTemporaryStorage',
          component:BasicSecond,
          meta:{
            keepAlive: true,
            isFrame: true,
            title: '秒报暂存'
          }
        },
        {
          name:'xlcmbDetail',
          path:'/xlcmbDetail',
          component:BasicSecond,
          meta:{
            keepAlive: true,
            isFrame: true,
            title: '秒报单详情'
          }
        },
        {
          path:'/yaInsreportsjd',
          name:'yaInsreportsjd',
          component:BasicIndex,
          meta:{
            title: '周期统计(询)',
            keepAlive: true,
            isFrame: true
          }
        },
        {
          path: '/salvageCarList',
          name: 'salvageCarList',
          component: BasicIndex,
          meta: {
            keepAlive: true,
            isFrame: true,
            title: '残值车列表',
          },
        },
        {
          path: '/successfulBidderList',
          name: 'successfulBidderList',
          component: BasicIndex,
          meta: {
            keepAlive: true,
            isFrame: true,
            title: '中标列表',
          }
        },
        {
          path: '/salvageCarInsert',
          name: 'salvageCarInsert',
          component: BasicIndex,
          meta: {
            keepAlive: true,
            isFrame: true,
            title: '残值车发布',
          },
        },
        {
          path: '/salvageCarDetail',
          name: 'salvageCarDetail',
          component: BasicSecond,
          meta: {
            keepAlive: true,
            isFrame: true,
            title: '残值车详情',
          },
        },
        {
          path:'/insreportsjdDaily',
          name:'insreportsjdDaily',
          component:BasicIndex,
          meta:{
            title: "单日统计(询)",
            keepAlive: true,
            isFrame: true
          }
        },
        {
          path:'/report',
          name:'report',
          component:BasicIndex,
          meta:{
            title: '统计',
            keepAlive: true,
            isFrame: true
          }
        },
        {
          path:'/pjscheck',
          name:'pjscheck',
          component:BasicIndex,
          meta:{
            title: '配件管理',
            keepAlive: true,
            isFrame: true
          }
        },
        {
          path:'/pjsupload',
          name:'pjsupload',
          component:BasicIndex,
          meta:{
            title: '上传配件',
            keepAlive: true,
            isFrame: true
          }
        },
        {
          path: '/black',
          name: 'black',
          component: ()=>import('@/components/navMain/mainComponents/black.vue'),
          meta:{
            keepAlive: true
          }
        },
        {
          name: 'index',
          path: '/index',
          component: ()=>import('@/page/home/index.vue'),
          meta: {
            title: '首页',
            keepAlive: true,
          }
        },
        {
          name:'queryPriceList',
          path: '/queryPriceList',
          component: ()=>import('@/page/order/QueryPriceList'),
          meta: {
            title: '报价列表',
            keepAlive: true,
            isFrame:false,
          }
        },
        {
          name:'quoteDetail',
          path: '/quoteDetail',
          component: BasicIndex,
          meta: {
            title: '被选中',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//EPC
          name:'epcindexv2',
          path: '/epcindexv2',
          component: BasicIndex,
          meta: {
            title: 'EPC查询',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//订单
          name:'sale',
          path: '/sale',
          component: BasicIndex,
          meta: {
            title: '平台服务费',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//我的订单
          name:'bxgsSale',
          path: '/bxgsSale',
          component: BasicIndex,
          meta: {
            title: '订单信息',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'OrderListseller',
          path: '/OrderListseller',
          component: BasicIndex,
          meta: {
            title: '售出订单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'OrderList',
          path: '/OrderList',
          component: BasicIndex,
          meta: {
            title: '我的下单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'queryEnquiryInfo',
          path: '/queryEnquiryInfo',
          component: (() => import('@/page/order/queryEnquiryInfo.vue')),
          meta: {
            title: '录入订单',
            keepAlive: true,
            isFrame:env!=='development',
          }
        },
        {
          name:'orderStagingDetail',
          path: '/orderStagingDetail',
          component: () => import('@/page/order/queryEnquiryInfo.vue'),
          meta: {
            title: '订单暂存详情',
            keepAlive: true,
          }
        },
        {//汽配厂或个人 订单列表
          name:'cjOrderList',
          path: '/cjOrderList',
          component: BasicIndex,
          meta: {
            title: '订单列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//汽配厂或个人 创建订单
          name:'cjqueryEnquiryInfo',
          path: '/cjqueryEnquiryInfo',
          component: BasicIndex,
          meta: {
            title: '创建订单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//滞销外销
          name:'unsalableIndex',
          path: '/unsalableIndex',
          component: BasicIndex,
          meta: {
            title: '滞销单列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'exportBidding',
          path: '/exportBidding',
          component: BasicIndex,
          meta: {
            title: '4S外销配件',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'unsalableInsert',
          path: '/unsalableInsert',
          component: BasicIndex,
          meta: {
            title: '发布滞销单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'unsalableBuyListFlag',
          path: '/unsalableBuyListFlag',
          component: BasicIndex,
          meta: {
            title: '售出列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'unsalableBuyList',
          path: '/unsalableBuyList',
          component: BasicIndex,
          meta: {
            title: '下单列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {// 滞销库存
          name:'fourSinsert',
          path: '/fourSinsert',
          component: BasicIndex,
          meta: {
            title: '发布滞销库存',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'fourSindexFlag',
          path: '/fourSindexFlag',
          component: BasicIndex,
          meta: {
            title: '滞销库存列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'fourSbuyListFlag',
          path: '/fourSbuyListFlag',
          component: BasicIndex,
          meta: {
            title: '售出列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'fourSbuyList',
          path: '/fourSbuyList',
          component: BasicIndex,
          meta: {
            title: '下单列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//配件外销
          name:'fourSexportBidding',
          path: '/fourSexportBidding',
          component: BasicIndex,
          meta: {
            title: '外销列表',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'fourSaddBidding',
          path: '/fourSaddBidding',
          component: BasicIndex,
          meta: {
            title: '发布外销包',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//4s店 保养
          name:'maintainIndex',
          path: '/maintainIndex',
          component: BasicIndex,
          meta: {
            title: '保养查询',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//秒报询价
          name:'jnmbPrice',
          path: '/jnmbPrice',
          component: BasicIndex,
          meta: {
            title: '秒报',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'jnxjPrice',
          path: '/jnxjPrice',
          component: BasicIndex,
          meta: {
            title: '询价',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'queryenquiryinfolist',
          path: '/queryenquiryinfolist',
          component: ()=>import('@/page/order/QueryPriceInfoList'),
          meta: {
            title: '询价列表',
            keepAlive: true,
            isFrame:false,
          }
        },
        {// 汽配厂
          name:'querypriceInfolist',
          path: '/querypriceInfolist',
          component: ()=>import('@/page/order/QueryPriceInfoList'),
          meta: {
            title: '询价单列表',
            keepAlive: true,
          }
        },
        {
          name:'queryenquiryinfolisteState',
          path: '/queryenquiryinfolisteState',
          component: BasicIndex,
          meta: {
            title: '暂存',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//设置
          name:'doUserInfo',
          path: '/doUserInfo',
          component: BasicIndex,
          meta: {
            title: '个人信息',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'mimaedit',
          path: '/mimaedit',
          component: BasicIndex,
          meta: {
            title: '修改密码',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'scopeedit',
          path: '/scopeedit',
          component: BasicIndex,
          meta: {
            title: '经营范围',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'queryuserdistrict',
          path: '/queryuserdistrict',
          component: BasicIndex,
          meta: {
            title: '报价区域',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'Relation',
          path: '/Relation',
          component: BasicIndex,
          meta: {
            title: '合作关系',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'chatlist',
          path: '/chatlist',
          component: BasicIndex,
          meta: {
            title: '聊天记录',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'Feebalance',
          path: '/Feebalance',
          component: BasicIndex,
          meta: {
            title: '查询充值',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//保险公司 报表统计
          name:'insreportsjd',
          path: '/insreportsjd',
          component: BasicIndex,
          meta: {
            title: '周期统计',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'insreport',
          path: '/insreport',
          component: BasicIndex,
          meta: {
            title: '单日统计',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'insdirectsupplysjd',
          path: '/insdirectsupplysjd',
          component: BasicIndex,
          meta: {
            title: '直供统计',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'inquiryList',
          path: '/inquiryList',
          component: BasicIndex,
          meta: {
            title: '询价清单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'EPCQueryList',
          path: '/EPCQueryList',
          component: BasicIndex,
          meta: {
            title: 'EPC查询清单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'EPCQueryPartList',
          path: '/EPCQueryPartList',
          component: BasicIndex,
          meta: {
            title: 'EPC零件清单',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//合作关系
          name:'cooperate',
          path: '/cooperate',
          component: BasicIndex,
          meta: {
            title: '配件商合作',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          name:'damagecar',
          path: '/damagecar',
          component: BasicIndex,
          meta: {
            title: '竞拍商合作',
            keepAlive: true,
            isFrame:true,
          }
        },
        {//店铺
          path: '/shopindex',
          name: 'shopindex',
          component: (resolve) => require(['../components/shop/shopindex.vue'], resolve),
          meta: {
            title: '我的店铺',
            keepAlive: true
          }
        },
        {
          path: '/shopdetail',
          name: 'shopdetail',
          component: (resolve) => require(['../components/shop/shopdetail.vue'], resolve),
          meta: {
            title: '商品详情',
            keepAlive: true
          }
        },
        {
          path: '/shopupd',
          name: 'shopupd',
          component: (resolve) => require(['../components/shop/shopupload.vue'], resolve),
          meta: {
            title: '上传商品',
            keepAlive: true
          }
        },
        {
          name:'myVisit',
          path: '/myVisit',
          component: (resolve) => require(['../components/shop/shopmyVisit.vue'], resolve),
          meta: {
            title: '我的店铺访客',
            keepAlive: true
          }
        },
        {
          name:'myshopvip',
          path: '/myshopvip',
          component: (resolve) => require(['../components/shop/myshopvip.vue'], resolve),
          meta: {
            title: '我的会员',
            keepAlive: true
          }
        },
        {
          name:'shopmanager',
          path: '/shopmanager',
          // component: (resolve) => require(['../components/shop/shopmanager.vue'], resolve),
          component:BasicIndex,
          meta: {
            title: '管理员/员工',
            keepAlive: true
          }
        },
        {
          name:'myshoplist',
          path: '/myshoplist',
          component: (resolve) => require(['../components/shop/myshoplist.vue'], resolve),
          meta: {
            title: '我的店铺商品',
            keepAlive: true
          }
        },
        {
          name:'aboutMeInfo',
          path: '/aboutMeInfo',
          component: (resolve) => require(['../components/shop/aboutMeInfo.vue'], resolve),
          meta: {
            title: '配件询价单',
            keepAlive: true
          }
        },
        {
          name: 'shopOrder',
          path: '/shopOrder',
          component: (resolve) => require(['../components/shop/shoporderlist.vue'], resolve),
          meta: {
            title: '我的店铺订单',
            keepAlive: true
          }
        },
        {
          path: '/buyvip',
          name: 'buyvip',
          component: (resolve) => require(['../components/shop/buyvip.vue'], resolve),
          meta: {
            title: '购买会员',
            keepAlive: true
          }
        },
        {
          path: '/search',
          name: 'search',
          component: (resolve) => require(['../components/IFrame/search.vue'], resolve),
          meta: {
            title: '搜索结果',
            keepAlive: true
          }
        },
        {
          path: '/mb',
          name: 'mb',
          component: BasicSecond,
          meta: {
            title: '秒报单详情',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          path: '/createPictureForm',
          name: 'createPictureForm',
          component: BasicSecond,
          meta: {
            title: '询价单详情',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          path: '/createFormTemporaryStorage',
          name: 'createFormTemporaryStorage',
          component:BasicSecond,
          meta: {
            title: '询价暂存',
            keepAlive: true,
            isFrame: true,
          }
        },
        {
          path: '/apsCreateDirectSupplyOrder',
          name: 'apsCreateDirectSupplyOrder',
          component:BasicSecond,
          meta: {
            title: '供货反馈',
            keepAlive: true,
            isFrame: true,
          }
        },
        {
          path: '/createForm',
          name: 'createForm',
          component:()=>import('@/page/order/InquiryOrderDetail'),
          meta: {
            title: '询价单详情',
            keepAlive: true,
            isFrame: false,
          }
        },
        {
          path: '/enquiryRecord',
          name: 'enquiryRecord',
          component: () => import('@/page/enquiry/enquiryRecord.vue'),
          meta:{
            title:'询价单录入',
            keepAlive: true,
            isFrame: false,
          }
        },
        {
          path: '/enquiryRecordStagingDetail',
          name: 'enquiryRecordStagingDetail',
          component: () => import('@/page/enquiry/enquiryRecord.vue'),
          meta:{
            title:'录入暂存详情',
            keepAlive: true,
            isFrame: false,
          }
        },
        {
          path: '/enquiryRecordStaging',
          name: 'enquiryRecordStaging',
          component: () => import('@/page/enquiry/enquiryRecordStaging.vue'),
          meta: {
            title: '录入暂存',
            keepAlive: true,
            isFrame: false
          }
        },
        {
          path: '/orderStaging',
          name: 'orderStaging',
          component: () => import('@/page/order/orderStaging.vue'),
          meta: {
            title: '录入订单暂存',
            keepAlive: true,
            isFrame: false
          }
        },
        {
          path: '/saleLaterService',
          name: 'saleLaterService',
          component: () => import('@/page/sale/saleLaterService.vue'),
          meta: {
            title: '申请售后',
            keepAlive: true,
          },
        },
        {
          path: '/jnquotedetail',
          name: 'jnquotedetail',
          component: ()=>import('@/page/order/QuoteDetail'),
          meta: {
            title: '报价详情',
            keepAlive: true,
          }
        },
        {
          path: '/quote_statistics',
          name: 'quote_statistics',
          component: () => import('@/page/order/quote_statistics'),
          meta: {
            title: '报价统计',
            keepAlive: true
          },
        },
        {
          path: '/getInfoByOEcode',
          name: 'getInfoByOEcode',
          component: BasicIndex,
          meta: {
            title: 'OE码查询',
            keepAlive: true,
            isFrame:true,
          }
        },
        {
          path:'/tiresHome',
          name:'tiresHome',
          component:()=>import('@/page/shop/tires.vue'),
          meta:{
            title: '轮胎搜索',
            keepAlive: true,
          }
        },
        {
          path:'/reconList',
          name:'reconList',
          component:()=>import('@/page/recon/list.vue'),
          meta:{
            title: '复勘列表',
            keepAlive: true,
          }
        },
        {
          path:'/reconAdd',
          name:'reconAdd',
          component:()=>import('@/page/recon/add.vue'),
          meta:{
            title: '复勘新增',
            keepAlive: true,
          }
        },
        {
          path:'/reconDetail',
          name:'reconDetail',
          component:()=>import('@/page/recon/detail.vue'),
          meta:{
            title: '复勘详情',
            keepAlive: true,
          }
        },
        {
          path:'/reconAppraisal',
          name:'reconAppraisal',
          component:()=>import('@/page/recon/appraisal.vue'),
          meta:{
            title:'复勘鉴定',
            keepAlive:true
          }
        },
        {
          path:'/notificationList',
          name:'notificationList',
          component: () => import('@/page/notification/notificationList.vue'),
          meta:{
            title:'通知列表',
            keepAlive: true
          }
        },
        {
          path: '/jia_an_pei_loginComponent',
          name: 'jia_an_pei_loginComponent',
          component: () => import('@/page/user/jia_an_pei_login.vue'),
          meta: {
            title: '驾安配登录',
            keepAlive: true,
          },
        }
      ]
    },
    {
      path:'*',
      redirect:'/'
    }
    // ...router
  ]
}
const routes = makeOriginRoutes()
export function getAllRoutesMeta(){
  const allRoutes = makeOriginRoutes()
  return allRoutes.reduce((total,item)=>{
    total.push(item)
    if(item.children) {
      total.push(...item.children)
      delete item.children
    }
    return total
  },[])
}

export default new Router({
    routes,
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        if (from.meta.keepAlive) {
          from.meta.savedPosition = document.body.scrollTop;
        }
        return { x: 0, y: to.meta.savedPosition || 0 }
      }
    }
})